import { render } from "./Tratamiento.vue?vue&type=template&id=277b696e&scoped=true&ts=true"
import script from "./Tratamiento.vue?vue&type=script&lang=ts"
export * from "./Tratamiento.vue?vue&type=script&lang=ts"

import "./Tratamiento.vue?vue&type=style&index=0&id=277b696e&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277b696e"]])

export default __exports__